"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_CA_TRANS = {
    'time picker': 'Selector de Temps',
    'today': 'Avui',
    'set time': 'Selecciona Temps',
    'close': 'Tancar',
    'cancel': '‪Cancelar‬',
    'confirm': 'Confirmar',
    'hour': 'Hora',
    'minute': 'Minut',
    'second': 'Segón',
};
//# sourceMappingURL=ca.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/ng-pick-datetime/locale/ca.js
// module id = ../../../../ng-pick-datetime/locale/ca.js
// module chunks = 18